import { render, staticRenderFns } from "./aiBannerPage.vue?vue&type=template&id=21f86abc&scoped=true&"
import script from "./aiBannerPage.vue?vue&type=script&lang=js&"
export * from "./aiBannerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f86abc",
  null
  
)

export default component.exports